import { isArray } from 'util';
import { ManufacturingOrderFiles } from '../manufacturing-order-files';
import { parseNumber } from '../../utils/number.utils';

export class ManufacturingOrderFilesBuilder {
  static fromJson(json) {
    return (json)
      ? new ManufacturingOrderFiles(
        parseNumber(json.existingFilesAmount)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ManufacturingOrderFilesBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order-files.builder.ts